module.exports = __webpack_public_path__ + "img/learn-spanish.65970717.png";